module.exports = __webpack_public_path__ + "img/check-in-green-circle.9ebbf29a.svg";